'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'heart';
var width = 512;
var height = 512;
var aliases = [128153,128154,128155,128156,128420,129293,129294,129505,9829,10084,61578];
var unicode = 'f004';
var svgPathData = ['M16 165.1c0 39.5 16.7 76.5 37.5 109.3 23.1 36.5 54.2 71.8 85.7 102.9 31.5 31 63 57.4 86.7 76.1 11.8 9.3 21.7 16.7 28.5 21.7 .5 .4 1.1 .8 1.5 1.1 .5-.4 1-.7 1.5-1.1 6.9-5 16.7-12.4 28.5-21.7 23.7-18.7 55.2-45.1 86.7-76.1 31.5-31.1 62.6-66.4 85.7-102.9 20.8-32.9 37.5-69.8 37.5-109.3 0-64.7-52.4-117.1-117.1-117.1-37.6 0-72.9 18-94.9 48.5l-28 38.7-28-38.7C206 66 170.7 48 133.1 48 68.4 48 16 100.4 16 165.1z', 'M256 496S0 319.4 0 167.7C0 94.2 58.6 32 133.1 32 175.8 32 216 52.5 241 87.1l15 20.7 15-20.7C296 52.5 336.2 32 378.9 32 453.5 32 512 94.2 512 167.7 512 319.4 256 496 256 496zm0-360.8L228 96.5c-22-30.5-57.3-48.5-94.9-48.5-64.7 0-117.1 52.4-117.1 117.1 0 39.5 16.7 76.5 37.5 109.3 23.1 36.5 54.2 71.8 85.7 102.9 31.5 31 63 57.4 86.7 76.1 11.8 9.3 21.7 16.7 28.5 21.7 .5 .4 1.1 .8 1.5 1.1 .5-.4 1-.7 1.5-1.1 6.9-5 16.7-12.4 28.5-21.7 23.7-18.7 55.2-45.1 86.7-76.1 31.5-31.1 62.6-66.4 85.7-102.9 20.8-32.9 37.5-69.8 37.5-109.3 0-64.7-52.4-117.1-117.1-117.1-37.6 0-72.9 18-94.9 48.5l-28 38.7z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHeart = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;